var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-footer',{staticClass:"footer"},[_c('p',[_vm._v("©copyright "+_vm._s(_vm.year)+" 北京大学王选计算机研究所")])])
}
var staticRenderFns = []

export { render, staticRenderFns }